import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/base/SEOHead';
import Breadcrumb from '@/components/feature/Breadcrumb';
import { articles } from '@/mocks/comics';

const siteUrl = 'http://iitzgd.cn/';

export default function ArticlesPage() {
  const pageUrl = `${siteUrl}/articles`;

  const schema = [
    {
      '@context': 'https://schema.org',
      '@type': 'CollectionPage',
      name: '文章资讯 - 韩漫大全',
      url: pageUrl,
      description: '韩漫大全文章资讯栏目，提供韩国漫画行业动态、新作推荐、深度分析等内容。',
      isPartOf: { '@type': 'WebSite', name: '韩漫大全', url: siteUrl },
      inLanguage: 'zh-CN',
    },
    {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [
        { '@type': 'ListItem', position: 1, name: '首页', item: siteUrl },
        { '@type': 'ListItem', position: 2, name: '文章资讯', item: pageUrl },
      ],
    },
  ];

  return (
    <>
      <SEOHead
        title="文章资讯_韩漫行业动态_新作推荐_韩漫大全"
        description="韩漫大全文章资讯栏目，提供韩国漫画行业动态、新作推荐、深度分析、入坑指南等高质量内容。了解韩漫最新趋势。"
        keywords="韩漫资讯,韩国漫画,漫画推荐,韩漫行业,新作盘点"
        canonicalUrl={pageUrl}
        schemaData={schema}
      />
      <Navbar />
      <main>
        <div className="pt-16">
          <Breadcrumb items={[{ label: '首页', to: '/' }, { label: '文章资讯' }]} />

          <section className="py-10 md:py-14 bg-background-50">
            <div className="mx-auto px-4 md:px-6 max-w-5xl">
              <div className="text-center mb-10">
                <h1 className="font-heading text-2xl md:text-4xl text-foreground-900 mb-3">文章资讯</h1>
                <p className="text-sm text-foreground-500 max-w-lg mx-auto">
                  韩漫行业动态、新作推荐、深度分析与入坑指南
                </p>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-6">
                {articles.map((article) => (
                  <Link
                    key={article.id}
                    to={`/comic/${article.id}`}
                    className="group flex flex-col sm:flex-row gap-4 p-4 rounded-lg bg-background-100 border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer"
                  >
                    <div className="w-full sm:w-48 aspect-video sm:aspect-[4/3] flex-shrink-0 rounded-md overflow-hidden bg-background-200">
                      <img
                        src={article.image}
                        alt={article.title}
                        title={article.title}
                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                      />
                    </div>
                    <div className="flex-1 min-w-0 flex flex-col justify-between">
                      <div>
                        <span className="inline-block px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-2">
                          {article.category}
                        </span>
                        <h2 className="font-heading text-base md:text-lg text-foreground-900 group-hover:text-primary-500 transition-colors leading-snug">
                          {article.title}
                        </h2>
                        <p className="text-sm text-foreground-500 mt-2 line-clamp-2">{article.excerpt}</p>
                      </div>
                      <div className="flex items-center gap-2 text-xs text-foreground-400 mt-3">
                        <span>{article.author}</span>
                        <span>·</span>
                        <span>{article.date}</span>
                      </div>
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          </section>
        </div>
      </main>
      <Footer />
    </>
  );
}
